// src/design/forms/datepicker/calendar-engine/constants/calendar-date.ts
var e = {
	en: [
		"Baishakh",
		"Jestha",
		"Ashadh",
		"Shrawan",
		"Bhadra",
		"Ashwin",
		"Kartik",
		"Mangsir",
		"Poush",
		"Magh",
		"Phalgun",
		"Chaitra"
	],
	ne: [
		"वैशाख",
		"जेठ",
		"असार",
		"साउन",
		"भदौ",
		"असौज",
		"कात्तिक",
		"मंसीर",
		"पुष",
		"माघ",
		"फागुन",
		"चैत"
	]
}, t = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
], n = {
	en: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	ne: [
		"आईत",
		"सोम",
		"मंगल",
		"बुध",
		"बिही",
		"शुक्र",
		"शनि"
	]
}, r = {
	0: "पुष - माघ",
	1: "माघ - फागुन",
	2: "फागुन - चैत",
	3: "चैत - वैशाख",
	4: "वैशाख - जेठ",
	5: "जेठ - असार",
	6: "असार - साउन",
	7: "साउन - भदौ",
	8: "भदौ - असौज",
	9: "असौज - कात्तिक",
	10: "कात्तिक - मंसीर",
	11: "मंसीर - पुष"
}, i = {
	0: "April - May",
	1: "May - June",
	2: "June - July",
	3: "July - August",
	4: "August - September",
	5: "September - October",
	6: "October - November",
	7: "November - December",
	8: "December - January",
	9: "January - February",
	10: "February - March",
	11: "March - April"
}, a = 2100, o = 1970, s = 2043, c = 1913, l = [
	[30, 31],
	[31, 32],
	[31, 32],
	[31, 32],
	[31, 32],
	[30, 31],
	[29, 30],
	[29, 30],
	[29, 30],
	[29, 30],
	[29, 30],
	[30, 31]
], u = [
	[
		0,
		1,
		1,
		22,
		1,
		3,
		1,
		1,
		1,
		3,
		1,
		22,
		1,
		3,
		1,
		3,
		1,
		22,
		1,
		3,
		1,
		19,
		1,
		3,
		1,
		1,
		3,
		1,
		2,
		2,
		1,
		3,
		1
	],
	[
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		3,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		1,
		2
	],
	[
		0,
		1,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		3,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		1,
		2
	],
	[
		1,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		2,
		2,
		1,
		3,
		1,
		2,
		2,
		2,
		1,
		2
	],
	[
		59,
		1,
		26,
		1,
		28,
		1,
		2,
		1,
		12
	],
	[
		0,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		5,
		1,
		1,
		2,
		2,
		1,
		3,
		1,
		2,
		1,
		2
	],
	[
		0,
		12,
		1,
		3,
		1,
		3,
		1,
		5,
		1,
		11,
		1,
		3,
		1,
		3,
		1,
		18,
		1,
		3,
		1,
		3,
		1,
		18,
		1,
		3,
		1,
		3,
		1,
		27,
		1,
		2
	],
	[
		1,
		2,
		2,
		2,
		2,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		3,
		1,
		3,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		2,
		2,
		2,
		15,
		2,
		4
	],
	[
		0,
		1,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		3,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		15,
		2,
		4
	],
	[
		1,
		1,
		3,
		1,
		3,
		1,
		14,
		1,
		3,
		1,
		1,
		1,
		3,
		1,
		14,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		18,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		14,
		1,
		3,
		15,
		1,
		2,
		1,
		1
	],
	[
		0,
		1,
		1,
		3,
		1,
		3,
		1,
		10,
		1,
		3,
		1,
		3,
		1,
		1,
		1,
		3,
		1,
		3,
		1,
		10,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		14,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		10,
		1,
		20,
		1,
		1,
		1
	],
	[
		1,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		3,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		3,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		3,
		1,
		3,
		1,
		20,
		3
	]
];
export { t as ENGLISH_MONTHS, u as bsMonthCalculatedData, l as bsMonthMaxDays, i as englishMonthMap, s as maxADYear, a as maxBSYear, c as minADYear, o as minBSYear, e as months, r as nepaliMonthMap, n as weeks };

//# sourceMappingURL=calendar-date.js.map